import { render } from "./Integer.vue?vue&type=template&id=2b2b2ff8&lang=pug"
import script from "./Integer.vue?vue&type=script&lang=js"
export * from "./Integer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__